import React, { useState, useContext, useEffect } from 'react';
import { DirectionsRenderer } from 'react-google-maps';
import { withTheme } from 'styled-components';
import StopMarker from 'modules/assignment-map/map/StopMarker';
import { getDirectionsOptions, getStopsDirections } from 'modules/assignment-map/map/utils';

import AssignmentMapContext from 'modules/assignment-map/map/context';

const JourneyStopsDrawer = withTheme(({ theme }) => {
  const { itinerary } = useContext(AssignmentMapContext);
  const [stopsDirections, setStopsDirections] = useState(null);
  const { stops = [] } = itinerary || {};

  const {
    base: { colorSchema },
  } = theme;

  useEffect(() => {
    const route = getStopsDirections(stops);
    const DirectionsService = new window.google.maps.DirectionsService();

    DirectionsService.route(route, (result, status) => {
      if (status !== window.google.maps.DirectionsStatus.OK) {
        console.error(`Error fetching directions ${result}`);
        return;
      }

      setStopsDirections(result);
    });
  }, [stops]);

  if (!stops.length) {
    return null;
  }

  return (
    <>
      {stops.map((stop, key) => {
        return (
          <StopMarker
            {...stop}
            variant="error500"
            key={`${stop?.latitude}${stop?.longitude}`}
            isFirst={key === 0}
            isLast={key === stops.length - 1}
            order={key + 1}
          />
        );
      })}
      {stopsDirections && (
        <DirectionsRenderer
          directions={stopsDirections}
          options={getDirectionsOptions({ strokeColor: colorSchema.error500 })}
        />
      )}
    </>
  );
});

export default JourneyStopsDrawer;
